import { defineMessages } from 'react-intl'

export default defineMessages({
  bookMeeting: {
    id: 'containers.OrderPage.components.TaskPage.components.BookLsMeeting.bookMeeting',
    defaultMessage: 'Book meeting',
  }
})